

import { useTableColumnsFactibilidadCorporativa, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { Grid, IconButton, Tooltip, } from '@mui/material';
import {
  EstadoFactibilidadCorporativaENUM,
  ROUTER_PATHS, TABLE_CONSTANTS,
} from '@/shared';
import { useNavigate } from 'react-router-dom';
import { Visibility } from '@mui/icons-material';
import { useFetchGetfactibilidadCorporativos } from '@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions';
import { IFactibilidadCorporativo } from '@/shared/interfaces/erp/factibilidad_corporativo';
import { useState } from 'react';



interface TableFactibilidadCorporativoProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_factibilidad?: EstadoFactibilidadCorporativaENUM
  aceptado_factibilidad?: boolean
  canEditGlobal?: boolean
  preaprobado_inventario?: boolean
  estado_preventa?: string
  // Filtros adicionales para estado_preventa - soporte de flujo independiente principal/backup
  estado_preventa_in?: string
  estado_preventa_exclude?: string
  enviado_inventario_factibilidad?: boolean
}

export default function TableFactibilidadCorporativo({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  estado_factibilidad = EstadoFactibilidadCorporativaENUM.PENDIENTE,
  aceptado_factibilidad,
  canEditGlobal = false,
  preaprobado_inventario = undefined,
  estado_preventa = undefined,
  estado_preventa_in = undefined,
  estado_preventa_exclude = undefined,
  enviado_inventario_factibilidad = undefined
}: TableFactibilidadCorporativoProps) {
  // useCheckPermissionsArray([
  //   PermissionsEnum.api_view_preventa,
  //   PermissionsEnum.api_change_preventa
  // ]);
  const [rowSelection, setRowSelection] = useState({});

  const navigate = useNavigate();

  ///* Hook
  const {
    columnsFactibilidad
  } = useTableColumnsFactibilidadCorporativa();

  ///* Fetch


  ///* Hook

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;


  const {
    isLoading,
    data: dataFactibilidadCorporativa,
    isRefetching
  } = useFetchGetfactibilidadCorporativos(
    {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      filterByState: false,
      estado_factibilidad: estado_factibilidad,
      aceptado_factibilidad: aceptado_factibilidad,
      preaprobado_inventario: preaprobado_inventario,
      estado_preventa: estado_preventa,
      estado_preventa_in: estado_preventa_in,
      estado_preventa_exclude: estado_preventa_exclude,
      enviado_inventario_factibilidad: enviado_inventario_factibilidad
    }
  );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IFactibilidadCorporativo>
            columns={columnsFactibilidad}
            data={dataFactibilidadCorporativa?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataFactibilidadCorporativa?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //check active 
            enableRowSelection
            enableSelectAll
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            pinLeftColumnIndexes={[0, 1, 2]}

            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn='first'
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            enableEditing={canEditGlobal && enableEditing}
            showCustomActionBtnSpace={canEditGlobal && showCustomActionBtnSpace}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    <Grid item >
                      <Tooltip placement='top' title='Ver Factibilidad Corporativa'>
                        <IconButton
                          onClick={() => {
                            //navigate(`${ROUTER_PATHS.ventas.preventaCorporativoViewNav}/${value.id_preventa_coorporativa}/${value.prospecto_data.id_prospecto}`);
                            navigate(`${ROUTER_PATHS.noc.factibilidadCorporativoNav}/revision/${value.id_factibilidad_coorporativa}`);

                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Grid>

                  </Grid>
                </>
              )
            }

            }

          />
        </Grid>
      </Grid>

    </>
  );


}

